import { render, staticRenderFns } from "./BlockAccount.vue?vue&type=template&id=f40c56cc&scoped=true&"
import script from "./BlockAccount.vue?vue&type=script&lang=ts&"
export * from "./BlockAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BlockAccount.vue?vue&type=style&index=0&id=f40c56cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40c56cc",
  null
  
)

export default component.exports